import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { EstadoCobroBadge, EstadoPagoBadge } from "@/components/LoadBadges";
import { money } from "@/components/reports/reportUtils";

export function ReporteLoads({ data }) {
  const items = data?.items || [];
  return (
    <div>
      {data?.truncado && (
        <p className="mb-2 text-xs font-medium text-amber-600" data-testid="reporte-loads-truncado">
          Hay más resultados de los que se muestran acá — usá los filtros de fecha para acotar, o exportá a Excel para verlos todos.
        </p>
      )}
      <Table data-testid="reporte-loads-table">
        <TableHeader>
          <TableRow>
            <TableHead>Load</TableHead><TableHead>Cliente</TableHead><TableHead>Ruta</TableHead>
            <TableHead>Pickup</TableHead><TableHead>Delivery</TableHead><TableHead>Operador</TableHead><TableHead className="text-right">Cobro</TableHead>
            <TableHead className="text-right">Costos</TableHead><TableHead className="text-right">Ganancia</TableHead>
            <TableHead className="text-right">Margen %</TableHead><TableHead>Cobro</TableHead><TableHead>Pago</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((d) => (
            <TableRow key={d.id || d.numero_load} data-testid={`reporte-loads-row-${d.numero_load}`}>
              <TableCell className="font-mono text-xs">{d.numero_load}</TableCell>
              <TableCell>{d.client_nombre}</TableCell>
              <TableCell className="text-xs">{d.origen_ciudad} → {d.destino_ciudad}</TableCell>
              <TableCell className="text-xs">{d.fecha_pickup}</TableCell>
              <TableCell className="text-xs">
                {d.fecha_delivery || "—"}
                {d.fecha_delivery_estimada && <span className="ml-1 text-amber-600">(estimado)</span>}
              </TableCell>
              <TableCell className="text-xs">{d.operador || "—"}</TableCell>
              <TableCell className="text-right">{money(d.monto_cobro_usd)}</TableCell>
              <TableCell className="text-right">{money(d.costos_total_usd)}</TableCell>
              <TableCell className="text-right">{money(d.ganancia_neta_usd)}</TableCell>
              <TableCell className="text-right">{d.margen_pct}%</TableCell>
              <TableCell><EstadoCobroBadge estado={d.estado_cobro_semaforo} dias={d.dias_vencimiento_cobro} /></TableCell>
              <TableCell><EstadoPagoBadge estado={d.estado_pago_carrier} /></TableCell>
            </TableRow>
          ))}
          {items.length === 0 && (
            <TableRow><TableCell colSpan={12} className="text-center text-sm text-muted-foreground py-8">Sin resultados para los filtros aplicados.</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
